{
  "SitePageTemplateSettings": {
    "ActionMenuLabel": "Tilgjengelige handlinger"
  },
  "components": {
    "AppLanguageSelector": {
      "toggleLanguageSwitcher": "Åpne/lukke språk-meny"
    },
    "BannerTitle": {
      "BannerBlockTitleAlignmentSelector": {
        "ActionMenuLabel": "Velg tekstjustering"
      },
      "BannerBlockTitleSizeSelector": {
        "ActionMenuLabel": "Velg tekststørrelse"
      },
      "BannerBlockTitleTransformationSelector": {
        "ActionMenuLabel": "Velg teksttransformasjon"
      },
      "BannerBlockTitleVerticalAlignmentSelector": {
        "ActionMenuLabel": "Velg vertikal tekstjustering"
      },
      "BannerBlockTitleWeightSelector": {
        "ActionMenuLabel": "Velg fonttykkelse"
      }
    },
    "CardEditor": {
      "Category": "Velg kategori",
      "Skin": "Velg farge"
    },
    "CommonBlockContent": {
      "Alignment": {
        "ActionMenuLabel": "Velg tekstjustering"
      }
    },
    "EditorBreadcrumbs": {
      "Description": "Stien til denne siden"
    },
    "EditorHeader": {
      "CreatePage": "Opprett ny side",
      "GoBack": "Gå tilbake"
    },
    "EditorPreviewContainer": {
      "AdditionalActions": "Flere handlinger for forhåndsvisning",
      "SelectDeviceType": "Velg enhetstype for forhåndsvisning"
    },
    "EditorSectionActionButton": {
      "ActionMenuLabel": "Tilgjengelige handlinger"
    },
    "EditorView": {
      "Tabs": "Kategorier av innhold du kan redigere"
    },
    "FilterMenu": {
      "MenuLabel": "Velg hvilke sider som skal vises"
    },
    "FinderLayout": {
      "CloseFinder": "Lukk finder",
      "ToggleFiltersOpen": "Åpne/Lukk filterseksjon"
    },
    "Header": {
      "navigateToHome": "Til Hjem",
      "toggleMenuButton": "Åpne/lukke meny"
    },
    "ListView": {
      "AddRemoveAsFavourite": "Legg til eller fjern fra favoritter",
      "SelectOrDeselect": "Inluder eller ekskluder fra valgte elementer"
    },
    "MainLayout": {
      "ToggleMenu": "Expand/Contract menu"
    },
    "PageBlockArticleTitleBlockTextAlignSetting": {
      "ActionMenuLabel": "Velg tekstjustering"
    },
    "PageBlockBannerLayoutSetting": {
      "ActionMenuLabel": "Velg layout"
    },
    "PageBlockBannerSizeSetting": {
      "ActionMenuLabel": "Velg størrelse"
    },
    "PageBlockCardModuleViewSetting": {
      "ActionMenuLabel": "Velg visning"
    },
    "PageBlockCollapsibleStateSetting": {
      "ActionMenuLabel": "Velg om seksjonen skal være sammenleggbar"
    },
    "PageBlockLayoutSetting": {
      "ActionMenuLabel": "Velg layout"
    },
    "PageBlockLinkListViewSetting": {
      "ActionMenuLabel": "Velg visningstype"
    },
    "PageBlockModuleLayoutSetting": {
      "ActionMenuLabel": "Velg modullayout"
    },
    "PageBlockModuleTypeSetting": {
      "ActionMenuLabel": "Velg modultype"
    },
    "PageBlockPageListLayoutSetting": {
      "ActionMenuLabel": "Velg layout"
    },
    "PageBlockPositionSetting": {
      "ActionMenuLabel": "Velg posisjon"
    },
    "PageBlockTextPositionSetting": {
      "ActionMenuLabel": "Velg tekstjustering"
    },
    "PageBlockTextSizeSetting": {
      "ActionMenuLabel": "Velg tekststørrelse"
    },
    "PageTree": {
      "ImportedPageTreeDescription": "Hierarki over importerte sider under domenet {{siteName}} som venter på plassering",
      "PageTreeDescription": "Hierarki over alle sider under domenet {{siteName}}"
    },
    "PageTreeActionMenu": {
      "MenuDescription": "Tilgjengelige handlinger for siden \"{{pageName}}\""
    },
    "PageTreeFilter": {
      "ClearAllFilters": "Fjern alle filter",
      "ClearQuery": "Tøm søk"
    },
    "SearchSelector": {
      "SearchFieldLabel": "Søk"
    },
    "SectionDirectionSelector": {
      "ActionMenuLabel": "Velg retning for seksjonens innhold"
    },
    "SectionDraggingPlaceholder": {
      "Label": "Dette er en midlertidig visning av elementet som flyttes"
    },
    "SectionDropIndicator": {
      "Label": "Dette er en indikator for hvor seksjonen vil bli flyttet"
    },
    "SectionWidthSelector": {
      "ActionMenuLabel": "Velg seksjonens bredde"
    },
    "SideMenuLayout": {
      "closeMenuButton": "Lukk meny"
    },
    "SkinSelector": {
      "SelectSkinTooltip": "Velg Skin"
    },
    "SortMenu": {
      "MenuLabel": "Velg hvordan sidene skal sorteres"
    },
    "SplitButton": {
      "ShowAllOptions": "Vis alle valg"
    },
    "UserAvatarMenu": {
      "toggleUserMenu": "Åpne/lukke bruker-meny"
    }
  },
  "preview": {
    "PreviewWrapper": {
      "ToggleDeveloperPreview": "Bytt mellom forhåndsvisning for utviklere"
    }
  }
}
